import { Box, Stack, Typography, Grid } from '@mui/material';

const CurrentVsTotal = ({
	currentNumber,
	totalNumber,
	classNames = {
		currentNumber: {},
		totalNumber: {},
	},
}) => {
	return (
		<Grid  sx={{
    padding: 0,
    margin: 0,
    height: 'auto',
    minHeight: 0,
  }}>
		<Stack
			direction="row"
			justifyContent="flex-start"
			alignItems="flex-end"
			spacing={0}
		>
			<Box>
				<Typography
					sx={{
						position: 'relative',
						lineHeight: 1,
						...classNames.currentNumber,
					}}
				>
					{currentNumber}
				</Typography>
			</Box>
			<Box>
				<Stack
					direction="column"
					justifyContent="flex-start"
					alignItems="flex-start"
					spacing={0}
				>
					
					<Box>
						<Typography
							sx={{
								color: 'black',
								lineHeight: 1.1,
								...classNames.totalNumber,
							}}
						>
							{`/${totalNumber}`}
						</Typography>
					</Box>
				</Stack>
			</Box>
		</Stack>
		</Grid>
	);
};

export default CurrentVsTotal;
